import {
  QuestionCircleTwoTone,
  ShopOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  Col,
  Drawer,
  Dropdown,
  Row,
  Space,
  Typography,
} from "antd";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HelpContent from "./HelpContent";
import { useCustomOidc } from "./oidc/customOidcUtils";
import { SwitchBroker } from "./SwitchBroker";

const { Text } = Typography;

const ActorMenu = () => {
  const navigate = useNavigate();
  const [helpContentOpen, setHelpContentOpen] = useState(false);
  const [switchSupportOpen, setSwitchSupportOpen] = useState(false);

  const { logout } = useCustomOidc();

  const actor = useSelector((state) => state.actor);
  const actorDetails = actor.details.data;

  const initials = useMemo(() => {
    const fullName = (actorDetails?.FullName ?? "").trim();
    if (!fullName) return "";
    const parts = fullName.split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] ?? "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
    return (first + last).toUpperCase();
  }, [actorDetails?.FullName]);

  const brokerTextFull = actorDetails ? (
    <span className="am-brokerWrap">
      <div className="am-brokerIcon">
        <ShopOutlined />
      </div>
      <Text className="am-broker">{actorDetails.AgencyFullName}</Text>
    </span>
  ) : null;

  const menuItems = [
    ...(actorDetails?.IsAdmin
      ? [{ key: "switch-broker", label: "Switch Broker" }]
      : []),
    { key: "settings", label: "User Settings and Preferences" },
    { key: "logout-button", label: "Logout" },
  ];

  const menu = {
    items: menuItems,
    onClick: ({ key }) => {
      if (key === "logout-button") {
        logout({ hasPressedLogout: true });
      } else if (key === "switch-broker") {
        setSwitchSupportOpen(true);
      } else if (key === "settings") {
        navigate("/userSettings");
      }
    },
  };

  return (
    <>
      <Drawer
        open={helpContentOpen}
        onClose={() => setHelpContentOpen(false)}
        width={450}
        title="Contact Support"
      >
        <HelpContent />
      </Drawer>

      <Drawer
        open={switchSupportOpen}
        onClose={() => setSwitchSupportOpen(false)}
        width={450}
        title="Switch Broker"
        destroyOnClose
      >
        <SwitchBroker onCloseHandler={() => setSwitchSupportOpen(false)} />
      </Drawer>

      <Row justify="end" wrap={false} style={{ paddingRight: "7px" }}>
        <Col>
          {process.env.REACT_APP_ENV !== "production" && (
            <Alert
              className="am-env"
              message={`${process.env.REACT_APP_ENV} environment`}
              showIcon
              type="warning"
            />
          )}
        </Col>
        <Col>{brokerTextFull}</Col>
        <Col>
          <div style={{ height: 64 }}>
            <Dropdown menu={menu}>
              <Button
                className="am-userBtn"
                style={{ padding: "3px 11px 5px" }}
                onClick={(e) => e.preventDefault()}
              >
                <Space>
                  <Avatar
                    size="small"
                    className="am-avatar"
                    style={{ backgroundColor: "#ec3a00" }}
                  >
                    {initials || <UserOutlined />}
                  </Avatar>

                  <span className="am-email">
                    {actorDetails?.DisplayEmail ?? ""}
                  </span>
                </Space>
              </Button>
            </Dropdown>
          </div>
        </Col>
        <Col>
          <div className="am-help">
            <QuestionCircleTwoTone
              onClick={() => setHelpContentOpen(true)}
              style={{ fontSize: "20px" }}
              twoToneColor="#ec3a00"
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ActorMenu;
